/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamMediaSource } from './oralExamMediaSource';

/**
 * Body for a client-reported media integrity change.

``source`` defaults to ``screen`` for backward compatibility with the
original screen-only report path.
 */
export interface OralExamReportMediaRequest {
  source?: OralExamMediaSource;
}
